import React, { useState, FormEvent, useEffect, useMemo } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Stack, Paper, Container } from '@mui/material'
import ProgressButton from '../../Utils/ProgressButton'
import { entityTextField } from '../../Utils/EntityField'
import { AppState } from '../../../reducers/index'
import { ProductGroupDetailState } from '../../../reducers/product/productGroupDetail'
import { upsertProductGroup } from '../../../actions/product/productGroupUpsert'
import ProductGroup from '../../../models/ProductGroup'
import { useTranslation } from 'react-i18next'
import { ISTableTitle } from '../../Utils/ISTable'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { fetchProductGroup } from '../../../actions/product/productGroupDetail'
import { BackButton } from '../../Utils/BackButton'
import Selector from '../../Selector'
import { isNil } from 'ramda'

interface Props {
  productGroup: ProductGroupDetailState
}

const empty: ProductGroup = {
  id: null,
  code: '',
  description: '',
  order: 0,
  ownerId: 0,
  ownerName: '',
  active: true
}

const ProductGroupUpsert: React.FC<Props> = ({ productGroup }) => {
  const [changed, setChanged] = useState<boolean>(false)
  const [productGroupInfo, setProductGroupInfo] = useState<ProductGroup>(productGroup.productGroup || empty)
  const { t } = useTranslation('product')
  const dispatch = useDispatch()
  const params = useParams<{ productGroupId: string }>()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (params.productGroupId) {
      dispatch(fetchProductGroup(params.productGroupId))
    }
  }, [dispatch, params.productGroupId])


  const change = (newProductGroupInfo: ProductGroup) => {
    setProductGroupInfo(newProductGroupInfo)
    setChanged(true)
  }

  const changeProductGroup = async (event: FormEvent) => {
    event.preventDefault()
    try {
      await dispatch(upsertProductGroup(productGroupInfo))
      setChanged(false)
      if (location.state)
        (location.state as any).update = !(location.state as any).update
      history.goBack()
    }
    catch {
    }
  }

  useEffect(() => {
    if (productGroup.productGroup) {
      setProductGroupInfo(params.productGroupId ? productGroup.productGroup : empty)
    }
  }, [productGroup.productGroup, params.productGroupId])

  const ProductGroupInfoField = useMemo(() => entityTextField(change), [])

  return (
    <Container>
      <Paper style={{ borderRadius: "10px", margin: "10px" }}>
        <ISTableTitle title={t('groups')} />
        <Paper style={{ padding: "10px" }}>
          <form onSubmit={changeProductGroup}>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ProductGroupInfoField
                style={{ width: "200px", marginRight: "10px" }}
                key="code"
                variant="outlined"
                label={t("code")}
                entity={productGroupInfo}
                attr="code"
                size="medium"
              />
              <ProductGroupInfoField
                //style={{ width: "100%"}}
                key="description"
                variant="outlined"
                label={t("description")}
                entity={productGroupInfo}
                attr="description"
                size="medium"
              />
            </Stack>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ProductGroupInfoField
                style={{ marginRight: "10px" }}
                key="order"
                variant="outlined"
                label={t("order")}
                entity={productGroupInfo}
                attr='order'
                size="medium"
              />
              <Selector
                key="active"
                label={t("active")}
                style={{ width: "100%" }}
                value={isNil(productGroupInfo.active) ? "" : Boolean(productGroupInfo.active)}
                textAdapter={(_value) => Boolean(_value) ? t("yes") : t("no")}
                menuItems={[true, false]}
              />
            </Stack>
            <Stack display="flex" flexDirection='row' justifyContent="space-between">
              <BackButton />
              <ProgressButton state={productGroup} disabled={!changed}>
                {t('save')}
              </ProgressButton>
            </Stack>
          </form>
        </Paper>
      </Paper>
    </Container>

  )
}

const mapStateToProps = (state: AppState) => ({
  productGroup: state.productGroupDetail
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(ProductGroupUpsert)
